import { render, staticRenderFns } from "./listView.vue?vue&type=template&id=2c6061e6&scoped=true&"
import script from "./listView.vue?vue&type=script&lang=js&"
export * from "./listView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6061e6",
  null
  
)

export default component.exports